(ns frontend.view.modals.curtains.exit-opportunity.on-hold-curtain
  (:require
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.view.modals.curtains.exit-opportunity.events :as events]
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :curtain.exit-opportunity/put-on-hold)

(defonce preset-months [1 2 3 6 12])

(defn month-options
  []
  (concat (->> preset-months
               (map (fn [num]
                      {:value num
                       :label (if (= num 1)
                                (loc/tr :month-one)
                                (loc/tr :months-num [num]))})))
          [{:value 0
            :label (loc/tr :select-custom-date)}]))

(defn month-selector
  [edit-state]
  [labelled-input/view
   {:editor-type   :editor.type/select
    :data-type     :data.type/number
    :label         (loc/tr :until)
    :mandatory?    true
    :is-clearable? false
    :value         (:months @edit-state)
    :options       (month-options)
    :on-change     (fn [new-value & _]
                     (if (nil? new-value)
                       (swap! edit-state dissoc :months)
                       (swap! edit-state assoc :months new-value)))}])

(defn until-selector
  [edit-state]
  [data-input/view
   {:data-type     :data.type/date
    :placeholder   (loc/tr :select-date)
    :is-clearable? false
    :full-width?   true
    :value         (:until @edit-state)
    :on-change     (fn [new-value]
                     (if (nil? new-value)
                       (swap! edit-state dissoc :until)
                       (swap! edit-state assoc :until new-value)))}])

(defn internal-comment-input
  [edit-state]
  [labelled-input/view
   {:data-type :data.type/text-simple
    :label     (loc/tr :put-on-hold-curtain/internal-comment)
    :value     (:internal-comment @edit-state)
    :on-change (fn [new-value]
                 (if (nil? new-value)
                   (swap! edit-state dissoc :internal-comment)
                   (swap! edit-state assoc :internal-comment new-value)))}])

(defn view
  [{:keys [_shown? _topmost? _close-modal! _props state _class-name]}]
  (let [edit-state (r/cursor state [:edit])]
    (fn [{:keys [shown? topmost? close-modal! props state _class-name]}]
      (let [{:keys [exit-opportunity-id reset-focus!]} props
            session-entities @session/entities
            exit-opportunity (get session-entities exit-opportunity-id)
            exit-opportunity-name (:exit-opportunity/name exit-opportunity)
            header-text (loc/tr :put-on-hold-curtain/title [exit-opportunity-name])
            edit-vals @edit-state
            {:keys [months until]} edit-vals
            close-modal! (fn []
                           (close-modal!)
                           (when reset-focus!
                             (reset-focus!)))
            button-disabled? (or (not (some #{months} (conj preset-months 0)))
                                 (and (zero? months)
                                      (nil? until)))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :color         ::c/warning
          :close-button? true}
         [:<>
          [:i {:class "fal fa-pause-circle mr-2"}]
          header-text]
         [:div
          {:class "flex flex-col gap-4"}
          [month-selector edit-state]
          (when (zero? months)
            [until-selector edit-state])
          [internal-comment-input edit-state]]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           ::c/warning
           button-disabled?
           (fn [_]
             (events/confirm-on-hold state exit-opportunity close-modal!))
           (loc/tr :exit-opportunity.put-on-hold-curtain/put-on-hold)
           nil]]]))))
